const MockData = {
  address: {
    addressLine1: 'Webergasse 1',
    postalCode: '01067',
    city: 'Dresden',
    countryCode: 'DE',
    formattedAddress: 'Webergasse 1, Sachsen, Dresden, 01067',
    location: {
      latitude: 51.049656,
      longitude: 13.736259
    }
  },
  category: 'RETAIL',
  storeId: 'b5e1a41dae4949b9acac6beba56822a9',
  isCertifiedStore: false,
  isOfficialStore: true,
  isLoyaltyEnabled: true,
  listingOption: 'NO',
  name: 'IQOS Store Dresden',
  openingHours: [
    {
      closingTime: '20:00',
      dayOfWeek: {
        index: 1,
        name: 'MONDAY'
      },
      openingTime: '10:00'
    },
    {
      closingTime: '20:00',
      dayOfWeek: {
        index: 2,
        name: 'TUESDAY'
      },
      openingTime: '10:00'
    },
    {
      closingTime: '20:00',
      dayOfWeek: {
        index: 3,
        name: 'WEDNESDAY'
      },
      openingTime: '10:00'
    },
    {
      closingTime: '20:00',
      dayOfWeek: {
        index: 4,
        name: 'THURSDAY'
      },
      openingTime: '10:00'
    },
    {
      closingTime: '20:00',
      dayOfWeek: {
        index: 5,
        name: 'FRIDAY'
      },
      openingTime: '10:00'
    },
    {
      closingTime: '20:00',
      dayOfWeek: {
        index: 6,
        name: 'SATURDAY'
      },
      openingTime: '10:00'
    },
    {
      closingTime: null,
      dayOfWeek: {
        index: 0,
        name: 'SUNDAY'
      },
      openingTime: null
    }
  ],
  splDaysOpeningHours: [],
  paymentMethods: ['DINERS', 'MASTERCARD', 'VISA', 'MAESTROCARD', 'KLARNA'],
  phone: '0800-1114-767',
  platformBrand: ['A01', 'A04'],
  services: [
    'ACCESSORIESSELLING',
    'APPOINTMENTS',
    'DEVICECUSTOMIZATION',
    'DEVICESELLING',
    'DEVICESERVICE',
    'EVENTS',
    'GUIDEDTRIAL',
    'HEETSSELLING',
    'VOUCHERREDEEM',
    'DEVICEACTIVATION',
    'VEEVCONSUMABLESELLING',
    'BLENDSSELLING',
    'VEEVNOWSELLING',
    'P1DEVICETAKEBACK',
    'P1STICKTAKEBACK',
    'VEEVNOWTAKEBACK',
    'VEEVONETAKEBACK',
    'VEEVPODSTAKEBACK',
    'VEEVONESELLING'
  ],
  storeInfoUse: 'STOREWITHWEB',
  subCategory: 'BRAND',
  subType: 'SMALLBOUTIQUE',
  type: 'IQOSSTORE'
}

// Mock data specifically for getStoreList responses
export const MockStoreListData = {
  paginationInfo: {
    totalItems: 3,
    currentPage: 1,
    totalPages: 1
  },
  items: [MockData]
}

// Mock data specifically for getStoreClusters responses
export const MockStoreClustersData = {
  storeClusters: [
    {
      storeCount: 2,
      isOfficialCluster: true,
      centroid: {
        latitude: 51.049656,
        longitude: 13.736259
      },
      topStore: MockData
    }
  ]
}

export default MockData
